export default __webpack_public_path__ + "static/media/Sgs.31849e02.png";